import { Span } from '../Typography'
import { Label } from './Label'
import { Error } from './styles'
import { Box } from '@gassan-ui'
import React, { FC } from 'react'
import { GridColumnProps, MarginBottomProps, MarginTopProps } from 'styled-system'

export type FieldControlProps = MarginBottomProps &
  MarginTopProps &
  GridColumnProps & {
    label?: React.ReactNode | string
    assistiveText?: string
    errorMsg?: string
    isCheckbox?: boolean
  }

export const FieldControl: FC<FieldControlProps> = ({
  label,
  assistiveText,
  errorMsg,
  children,
  isCheckbox = false,
  mb = '1.5rem',
  ...rest
}) => {
  return (
    <Box {...rest} position="relative" mb={mb} pt="3">
      {children}
      {label ? typeof label === 'string' && <Label>{label}</Label> : label}
      {assistiveText ? (
        <Span display="block" fontSize=".75rem" mt={2} color="shades.500">
          {assistiveText}
        </Span>
      ) : errorMsg ? (
        <Error errorOnTop={isCheckbox}>{errorMsg}</Error>
      ) : null}
    </Box>
  )
}

FieldControl.defaultProps = {
  mb: 3,
}
